import { render, staticRenderFns } from "./SanteSeniors.vue?vue&type=template&id=d94582fa&scoped=true&"
import script from "./SanteSeniors.vue?vue&type=script&lang=js&"
export * from "./SanteSeniors.vue?vue&type=script&lang=js&"
import style1 from "./SanteSeniors.vue?vue&type=style&index=1&id=d94582fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d94582fa",
  null
  
)

export default component.exports